import React, { useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { Category, Maybe } from '../../../../../types';
import * as S from '../styles';

type Props = {
  category?: Maybe<Category>;
};

const PriceListPlaceholder = ({ category }: Props) => {
  const { t } = useContext(AppContext);
  return (
    <S.Placeholder>
      <S.PlaceholderTitle>
        {t('product', 'prices.no-prices')}
      </S.PlaceholderTitle>
      {category && (
        <S.PlaceholderCategory>
          {t('product', 'prices.view-all-in-category-link')}{' '}
          <S.PlaceholderLink to={category.pathName}>
            {category.name}
          </S.PlaceholderLink>
        </S.PlaceholderCategory>
      )}
    </S.Placeholder>
  );
};

export default PriceListPlaceholder;
